module.exports = __webpack_public_path__ + "static/media/pk-pro-cover.b93611e1.jpg";